import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { CopyButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CodeWidget = ({ scriptInfo }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.CodeContainer>
      <Text type="titleS">{t('Código')}</Text>

      <Text type="bodyMRegular" customStyles={{ marginTop: theme.spacing.sp16 }}>
        {t('Copia este código y añádelo al HTML donde quieras que aparezca el widget de bracketing.')}
      </Text>
      <Styles.Code>
        <Text type="bodyMonospaced" color={theme.colors.outline.default}>
          {scriptInfo}
        </Text>
        <CopyButton info={scriptInfo} />
      </Styles.Code>
    </Styles.CodeContainer>
  )
}

export default CodeWidget
